import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface InstallWalkthroughProps {
  onClose: () => void;
  onDone: () => void;
}

function PulsingTarget({
  top,
  bottom,
  left,
  right,
  transform,
}: {
  top?: number | string;
  bottom?: number | string;
  left?: number | string;
  right?: number | string;
  transform?: string;
}) {
  return (
    <div
      style={{
        position: 'absolute',
        top,
        bottom,
        left,
        right,
        transform,
        zIndex: 10,
        width: 56,
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        marginLeft: left === '50%' ? -28 : undefined,
        marginBottom: bottom !== undefined ? -28 : undefined,
      }}
    >
      <div
        style={{
          position: 'absolute',
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: 'rgba(225,29,72,0.3)',
          animation: 'pulse-ring 1.4s infinite',
        }}
      />
      <div
        style={{
          position: 'absolute',
          width: 44,
          height: 44,
          borderRadius: '50%',
          background: 'rgba(225,29,72,0.4)',
          animation: 'pulse-ring 1.4s 0.3s infinite',
        }}
      />
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          background: '#e11d48',
          border: '3px solid #fff',
          boxShadow: '0 2px 12px rgba(225,29,72,0.6)',
        }}
      />
    </div>
  );
}

function Step1Safari() {
  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          background: '#1c1c1e',
          borderRadius: 40,
          border: '3px solid #3a3a3c',
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0,0,0,0.8)',
        }}
      >
        <div style={{ background: '#ffffff', minHeight: 300, position: 'relative' }}>
          <div
            style={{
              background: '#f2f2f7',
              padding: '12px 20px 8px',
              borderBottom: '1px solid #d1d1d6',
            }}
          >
            <div
              style={{
                background: '#ffffff',
                borderRadius: 10,
                padding: '8px 14px',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}
            >
              <span style={{ fontSize: 12, color: '#8e8e93' }}>🔒</span>
              <span style={{ fontSize: 14, color: '#000', fontWeight: 500 }}>papacitoapp.com</span>
            </div>
          </div>

          <div style={{ padding: 20, filter: 'blur(3px)', opacity: 0.4 }}>
            <div
              style={{
                background: '#e11d48',
                borderRadius: 8,
                height: 40,
                marginBottom: 12,
                width: '60%',
              }}
            />
            <div
              style={{
                background: '#e5e7eb',
                borderRadius: 6,
                height: 14,
                marginBottom: 8,
                width: '80%',
              }}
            />
            <div style={{ background: '#e5e7eb', borderRadius: 6, height: 14, width: '65%' }} />
          </div>

          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: 'rgba(242,242,247,0.95)',
              backdropFilter: 'blur(10px)',
              borderTop: '0.5px solid #c6c6c8',
              padding: '12px 0 8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-around',
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg width="12" height="20" viewBox="0 0 12 20">
                <path
                  d="M10 2L2 10L10 18"
                  stroke="#007AFF"
                  strokeWidth="2.5"
                  fill="none"
                  strokeLinecap="round"
                />
              </svg>
            </div>

            <div
              style={{
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                opacity: 0.3,
              }}
            >
              <svg width="12" height="20" viewBox="0 0 12 20">
                <path
                  d="M2 2L10 10L2 18"
                  stroke="#8e8e93"
                  strokeWidth="2.5"
                  fill="none"
                  strokeLinecap="round"
                />
              </svg>
            </div>

            <div
              style={{
                width: 44,
                height: 44,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                zIndex: 2,
              }}
            >
              <svg width="22" height="26" viewBox="0 0 22 26">
                <rect
                  x="4"
                  y="10"
                  width="14"
                  height="14"
                  rx="3"
                  stroke="#007AFF"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  d="M11 0 L11 17 M6 5 L11 0 L16 5"
                  stroke="#007AFF"
                  strokeWidth="2.5"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <div
              style={{
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <svg width="18" height="22" viewBox="0 0 18 22">
                <path d="M2 2h14v18l-7-5-7 5V2z" stroke="#8e8e93" strokeWidth="1.5" fill="none" />
              </svg>
            </div>

            <div
              style={{
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  width: 20,
                  height: 16,
                  border: '2px solid #8e8e93',
                  borderRadius: 4,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 9,
                  color: '#8e8e93',
                  fontWeight: 700,
                }}
              >
                1
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            background: '#1c1c1e',
            padding: '8px 0 12px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            style={{ width: 120, height: 5, background: '#ffffff', borderRadius: 3, opacity: 0.3 }}
          />
        </div>
      </div>

      <PulsingTarget bottom={56} left="50%" transform="translateX(-50%)" />

      <div
        style={{
          position: 'absolute',
          bottom: 110,
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <div style={{ animation: 'arrow-bounce-y 1s infinite' }}>
          <div
            style={{
              background: '#e11d48',
              color: '#fff',
              fontSize: 14,
              fontWeight: 800,
              padding: '6px 16px',
              borderRadius: 20,
              whiteSpace: 'nowrap',
            }}
          >
            TAP HERE ↓
          </div>
        </div>
      </div>
    </div>
  );
}

function Step2ShareSheet() {
  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          background: '#1c1c1e',
          borderRadius: 40,
          border: '3px solid #3a3a3c',
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0,0,0,0.8)',
        }}
      >
        <div style={{ background: '#ffffff', minHeight: 300, position: 'relative' }}>
          <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)' }} />

          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              background: '#f2f2f7',
              borderRadius: '16px 16px 0 0',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                padding: '12px 16px',
                background: '#fff',
                borderBottom: '0.5px solid #d1d1d6',
                display: 'flex',
                gap: 16,
                overflowX: 'auto',
              }}
            >
              {['AirDrop', 'Message', 'Mail', 'Notes'].map((app, i) => (
                <div
                  key={i}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 4,
                    flexShrink: 0,
                  }}
                >
                  <div style={{ width: 44, height: 44, borderRadius: 10, background: '#e5e7eb' }} />
                  <span style={{ fontSize: 10, color: '#000', textAlign: 'center' }}>{app}</span>
                </div>
              ))}
            </div>

            {[
              { icon: '⭐', label: 'Add to Favourites' },
              { icon: '🔍', label: 'Find on Page' },
              { icon: '➕', label: 'Add to Home Screen', highlighted: true },
              { icon: '✏️', label: 'Markup' },
            ].map((item, i) => (
              <div
                key={i}
                style={{
                  padding: '14px 16px',
                  background: item.highlighted ? 'rgba(225,29,72,0.08)' : '#ffffff',
                  borderBottom: '0.5px solid #d1d1d6',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 14,
                  position: 'relative',
                }}
              >
                <span style={{ fontSize: 20, width: 24, textAlign: 'center' }}>{item.icon}</span>
                <span
                  style={{
                    fontSize: 15,
                    color: '#000',
                    fontWeight: item.highlighted ? 700 : 400,
                    flex: 1,
                  }}
                >
                  {item.label}
                </span>
                {item.highlighted && <span style={{ fontSize: 16, color: '#e11d48' }}>←</span>}
              </div>
            ))}
          </div>
        </div>

        <div
          style={{
            background: '#1c1c1e',
            padding: '8px 0 12px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            style={{ width: 120, height: 5, background: '#ffffff', borderRadius: 3, opacity: 0.3 }}
          />
        </div>
      </div>

      <PulsingTarget bottom={112} left="50%" transform="translateX(-50%)" />

      <div
        style={{
          position: 'absolute',
          bottom: 165,
          left: '50%',
          transform: 'translateX(-50%)',
          whiteSpace: 'nowrap',
        }}
      >
        <div style={{ animation: 'arrow-bounce-y 1s infinite' }}>
          <div
            style={{
              background: '#e11d48',
              color: '#fff',
              fontSize: 14,
              fontWeight: 800,
              padding: '6px 16px',
              borderRadius: 20,
            }}
          >
            TAP THIS ↓
          </div>
        </div>
      </div>
    </div>
  );
}

function Step3AddButton() {
  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          background: '#1c1c1e',
          borderRadius: 40,
          border: '3px solid #3a3a3c',
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(0,0,0,0.8)',
        }}
      >
        <div style={{ background: '#f2f2f7', minHeight: 300, position: 'relative' }}>
          <div
            style={{
              background: 'rgba(242,242,247,0.95)',
              padding: '12px 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: '0.5px solid #d1d1d6',
            }}
          >
            <span style={{ color: '#007AFF', fontSize: 16 }}>Cancel</span>
            <span style={{ color: '#000', fontSize: 16, fontWeight: 600 }}>Add to Home Screen</span>
            <div style={{ position: 'relative' }}>
              <span
                style={{
                  color: '#007AFF',
                  fontSize: 16,
                  fontWeight: 700,
                  padding: '4px 8px',
                  background: 'rgba(0,122,255,0.1)',
                  borderRadius: 8,
                }}
              >
                Add
              </span>
            </div>
          </div>

          <div
            style={{
              margin: 20,
              background: '#fff',
              borderRadius: 16,
              padding: 16,
              boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
              display: 'flex',
              alignItems: 'center',
              gap: 14,
            }}
          >
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: 14,
                background: 'linear-gradient(135deg, #e11d48, #9333ea)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 28,
                flexShrink: 0,
              }}
            >
              🔥
            </div>
            <div>
              <p style={{ fontSize: 16, fontWeight: 600, color: '#000', margin: '0 0 4px' }}>
                Papacito
              </p>
              <p style={{ fontSize: 13, color: '#8e8e93', margin: 0 }}>papacitoapp.com</p>
            </div>
          </div>

          <div
            style={{
              margin: '0 20px',
              background: '#fff',
              borderRadius: 12,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span style={{ fontSize: 15, color: '#000' }}>Papacito</span>
            <span style={{ fontSize: 13, color: '#8e8e93' }}>Name</span>
          </div>

          <p style={{ padding: '8px 24px', fontSize: 12, color: '#8e8e93', lineHeight: 1.5 }}>
            An icon will be added to your Home Screen so you can quickly access this website.
          </p>
        </div>

        <div
          style={{
            background: '#1c1c1e',
            padding: '8px 0 12px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            style={{ width: 120, height: 5, background: '#ffffff', borderRadius: 3, opacity: 0.3 }}
          />
        </div>
      </div>

      <PulsingTarget top={52} right={28} />

      <div
        style={{
          position: 'absolute',
          top: 100,
          right: 24,
          animation: 'arrow-bounce-up 1s infinite',
        }}
      >
        <div
          style={{
            background: '#e11d48',
            color: '#fff',
            fontSize: 14,
            fontWeight: 800,
            padding: '6px 16px',
            borderRadius: 20,
            whiteSpace: 'nowrap',
          }}
        >
          ↑ TAP ADD
        </div>
      </div>
    </div>
  );
}

function InstallSuccessScreen({ onClose }: { onClose: () => void }) {
  return (
    <motion.div
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 10000,
        background: '#000',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: 32,
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 72 }}>🎉</div>

      <h2 style={{ color: '#fff', fontSize: 28, fontWeight: 800, margin: 0 }}>You're all set!</h2>

      <p
        style={{
          color: 'rgba(255,255,255,0.6)',
          fontSize: 16,
          margin: 0,
          lineHeight: 1.6,
          maxWidth: 280,
        }}
      >
        Papacito is now on your home screen. Open it anytime for instant match alerts 🔥
      </p>

      <div
        style={{
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: 20,
          padding: '20px 32px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: 18,
            background: 'linear-gradient(135deg, #e11d48, #9333ea)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 34,
            boxShadow: '0 8px 24px rgba(225,29,72,0.4)',
          }}
        >
          🔥
        </div>
        <span style={{ color: '#fff', fontSize: 13, fontWeight: 500 }}>Papacito</span>
      </div>

      <button
        onClick={onClose}
        style={{
          background: '#e11d48',
          color: '#fff',
          border: 'none',
          borderRadius: 14,
          padding: '16px 48px',
          fontSize: 17,
          fontWeight: 700,
          cursor: 'pointer',
          marginTop: 8,
          boxShadow: '0 4px 20px rgba(225,29,72,0.4)',
        }}
      >
        Keep Swiping 🔥
      </button>
    </motion.div>
  );
}

export function InstallWalkthrough({ onClose, onDone }: InstallWalkthroughProps) {
  const [step, setStep] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleNext = () => {
    if (step < 2) {
      setStep(step + 1);
    } else {
      setShowSuccess(true);
    }
  };

  if (showSuccess) {
    return (
      <InstallSuccessScreen
        onClose={() => {
          setShowSuccess(false);
          onDone();
        }}
      />
    );
  }

  return (
    <motion.div
      initial={{ y: '100%' }}
      animate={{ y: 0 }}
      exit={{ y: '100%' }}
      transition={{ type: 'spring', damping: 28 }}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: '#000000',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '56px 24px 16px',
          flexShrink: 0,
        }}
      >
        <button
          onClick={onClose}
          style={{
            background: 'rgba(255,255,255,0.1)',
            border: 'none',
            borderRadius: '50%',
            width: 36,
            height: 36,
            color: '#fff',
            fontSize: 16,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          ✕
        </button>

        <div style={{ display: 'flex', gap: 8 }}>
          {[0, 1, 2].map(i => (
            <div
              key={i}
              style={{
                width: i === step ? 24 : 8,
                height: 8,
                borderRadius: 4,
                background: i === step ? '#e11d48' : 'rgba(255,255,255,0.2)',
                transition: 'all 0.3s ease',
              }}
            />
          ))}
        </div>

        <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, fontWeight: 600 }}>
          {step + 1} / 3
        </span>
      </div>

      <div style={{ padding: '0 24px 16px', flexShrink: 0 }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={step}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
          >
            {step === 0 && (
              <>
                <h2
                  style={{
                    color: '#fff',
                    fontSize: 26,
                    fontWeight: 800,
                    margin: '0 0 6px',
                    lineHeight: 1.2,
                  }}
                >
                  Step 1 — Tap Share
                </h2>
                <p
                  style={{
                    color: 'rgba(255,255,255,0.55)',
                    fontSize: 16,
                    margin: 0,
                    lineHeight: 1.5,
                  }}
                >
                  Tap the <strong style={{ color: '#fff' }}>Share button (⬆️)</strong> at the bottom
                  of Safari, or tap the <strong style={{ color: '#fff' }}>••• menu</strong> button
                </p>
              </>
            )}
            {step === 1 && (
              <>
                <h2
                  style={{
                    color: '#fff',
                    fontSize: 26,
                    fontWeight: 800,
                    margin: '0 0 6px',
                    lineHeight: 1.2,
                  }}
                >
                  Step 2 — Add to Home Screen
                </h2>
                <p
                  style={{
                    color: 'rgba(255,255,255,0.55)',
                    fontSize: 16,
                    margin: 0,
                    lineHeight: 1.5,
                  }}
                >
                  <strong style={{ color: '#fff' }}>Scroll down</strong> in the menu and tap{' '}
                  <strong style={{ color: '#fff' }}>"Add to Home Screen"</strong>
                </p>
              </>
            )}
            {step === 2 && (
              <>
                <h2
                  style={{
                    color: '#fff',
                    fontSize: 26,
                    fontWeight: 800,
                    margin: '0 0 6px',
                    lineHeight: 1.2,
                  }}
                >
                  Step 3 — Tap "Add"
                </h2>
                <p
                  style={{
                    color: 'rgba(255,255,255,0.55)',
                    fontSize: 16,
                    margin: 0,
                    lineHeight: 1.5,
                  }}
                >
                  It's in the <strong style={{ color: '#fff' }}>top right corner</strong> of the
                  screen. Tap it and you're done!
                </p>
              </>
            )}
          </motion.div>
        </AnimatePresence>
      </div>

      <div
        style={{
          flex: 1,
          padding: '0 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <AnimatePresence mode="wait">
          <motion.div
            key={step}
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -40 }}
            transition={{ duration: 0.25 }}
            style={{ width: '100%', maxWidth: 340 }}
          >
            {step === 0 && <Step1Safari />}
            {step === 1 && <Step2ShareSheet />}
            {step === 2 && <Step3AddButton />}
          </motion.div>
        </AnimatePresence>
      </div>

      <div style={{ padding: '16px 24px 48px', flexShrink: 0 }}>
        <motion.button
          whileTap={{ scale: 0.97 }}
          onClick={handleNext}
          style={{
            width: '100%',
            background: '#e11d48',
            color: '#fff',
            border: 'none',
            borderRadius: 16,
            padding: '18px 0',
            fontSize: 18,
            fontWeight: 700,
            cursor: 'pointer',
            boxShadow: '0 4px 24px rgba(225,29,72,0.4)',
          }}
        >
          {step < 2 ? 'Got it — Next Step →' : "Done! I've Added It ✅"}
        </motion.button>

        {step === 2 && (
          <button
            onClick={onClose}
            style={{
              width: '100%',
              background: 'transparent',
              border: 'none',
              color: 'rgba(255,255,255,0.3)',
              fontSize: 14,
              cursor: 'pointer',
              padding: '12px 0',
              marginTop: 4,
            }}
          >
            I'll do it later
          </button>
        )}
      </div>
    </motion.div>
  );
}
